/** Returns an owned ArrayBuffer whose lifetime and type do not depend on the
 * backing buffer of the supplied Uint8Array. Useful at DOM Blob/File and File
 * System Access boundaries, which require ArrayBuffer-backed views. */
export function copyBytesToArrayBuffer(bytes: Uint8Array): ArrayBuffer {
  const copy = new Uint8Array(bytes.byteLength);
  copy.set(bytes);
  return copy.buffer;
}
